// ─────────────────────────────────────────────────────────────
// 新版工作項目轉換(cutover)—— 目前設為「無限期並行」
//
// 決策(2026-08):不設轉換截止日。新舊版無限期並行:
//   topbar 保留新舊切換開關、預設進新版,?v=old 永遠可切回舊版。
//   → 舊 Ticket 續留舊版 UI 可查,不需轉置成工作項目。
// 未來若要全面下架舊版:直接隱藏切換 component / 舊版 view,不靠這個日期。
//   (要恢復自動轉換:把 WORKITEM_CUTOVER 設回真實日期、
//    isAfterCutover 改回 Date.now() >= WORKITEM_CUTOVER.getTime() 即可。)
// ─────────────────────────────────────────────────────────────
export const WORKITEM_CUTOVER = null; // null = 無限期,不設轉換截止

// 是否已過轉換期:無限期模式恆為 false(永不強制切新版、不自動隱藏切換鈕)
export const isAfterCutover = () => false;

// 版本判定:
//   轉換後 → 恆為新版(忽略 ?v)
//   轉換前 → 預設新版,僅 ?v=old 顯示舊版
export const isNewWorkItemUI = (searchParams) => {
  if (isAfterCutover()) return true;
  return searchParams?.get('v') !== 'old';
};
